import React from 'react';
import { Translate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import NoDataComponent from '../../common/noDataComponent';

class ESGDataSources extends React.Component {

    shouldComponentUpdate(nextProps, _) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    render() {
        return (isNullOrUndefined(this.props.data) ? <NoDataComponent /> : <div>{this.renderContent(this.props.data)}</div>);
    }

    renderContent(data) {
        return (
            <table className="table table-report-section">
                <thead>
                    <tr>
                        <th><Translate id="Report.Common.Source" /></th>
                        <th><Translate id="Report.ESG.SourceDescription" /></th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((d, idx) => {
                        return (
                            <tr key={idx}>
                                <td>{d.source}</td>
                                <td>{d.description}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        )
    }

}

export default connect(state => state.report)(ESGDataSources);